"use client";

import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type ForeignNationalState = {
  uid: string;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  email: string;
  avatarSrc: string;
};

type UpdateAvatar = {
  avatarSrc: string;
  avatarName: string;
};

const initialState: ForeignNationalState = {
  uid: "",
  firstName: "",
  middleName: "",
  lastName: "",
  email: "",
  avatarSrc: ""
};

export const foreignNationalSlice = createSlice({
  name: "foreignNational",
  initialState,
  reducers: {
    setForeignNationalData: (
      _state,
      action: PayloadAction<ForeignNationalState>
    ) => action.payload,
    resetForeignNationalData: () => initialState,
    setForeignNationalUid: (state, action: PayloadAction<string>) => {
      state.uid = action.payload;
    },
    updateForeignNationalAvatar: (
      state,
      action: PayloadAction<UpdateAvatar>
    ) => {
      state.avatarSrc = action.payload.avatarSrc;
    }
  }
});

export const {
  setForeignNationalData,
  resetForeignNationalData,
  setForeignNationalUid,
  updateForeignNationalAvatar
} = foreignNationalSlice.actions;

export default foreignNationalSlice.reducer;
